<template>
  <div class="home">
    <b-container>
      <b-row class="bg-dkblue header">
      </b-row>
    </b-container>

    <img class="logo-welcome" id="logo" alt="logo" src="../assets/logos/mdcai_logo_white_v1.svg"><br />

This e-mail address has already been used to register.<br />
If you've forgotten your password, please select the Login button, then select the Forgot Password option.<br />
For additional help, please contact <a href="mailto:mdcai@avconcepts.com">mdcai@avconcepts.com</a> for assistance.<br /><br />

    <b-button-group vertical>
      <b-button squared class="btn-welcome" @click="$router.push('/')">Home</b-button>
      <b-button squared class="btn-welcome" :href="this.$store.state.locals.apiUrl + '/auth/login'">Login</b-button>
    </b-button-group>

  </div>
</template>





<script>
export default {
  mounted() {
    this.$store.state.loadingOverlay = false
  }
}
</script>
